import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Menu, X, ShoppingBag } from 'lucide-react';
import { useState } from 'react';

const SWIGGY_URL = process.env.REACT_APP_SWIGGY_URL;
const LOGO_URL = 'https://customer-assets.emergentagent.com/job_chaat-fresh/artifacts/22020fsm_2%20bowl%20final.png';

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Menu', path: '/menu' },
    { name: 'New Additions', path: '/new-additions' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'About', path: '/about' },
    { name: 'Contact', path: '/contact' }
  ];

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className="fixed top-0 w-full bg-cream/95 backdrop-blur-md z-50 border-b-2 border-brown-light/20 shadow-sm"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center gap-3" data-testid="logo-link">
            <img src={LOGO_URL} alt="Chaat-De-Licious" className="h-16 w-auto" />
            <span className="text-2xl lg:text-3xl font-playfair font-bold text-[#8B0000] hidden sm:block">
              Chaat-De-Licious
            </span>
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="text-brown-dark hover:text-spice transition-colors font-lato font-medium"
                data-testid={`nav-${link.name.toLowerCase().replace(' ', '-')}`}
              >
                {link.name}
              </Link>
            ))}
            <a
              href={SWIGGY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-spice text-white px-6 py-2.5 rounded-full hover:bg-spice-hover transition-all transform hover:-translate-y-0.5 hover:shadow-lg font-bold flex items-center gap-2"
              data-testid="nav-order-now-btn"
            >
              <ShoppingBag size={18} />
              Order Now
            </a>
          </div>

          <button
            className="md:hidden text-brown-dark"
            onClick={() => setIsOpen(!isOpen)}
            data-testid="mobile-menu-btn"
          >
            {isOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </div>

      {isOpen && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0 }}
          className="md:hidden bg-cream-secondary border-t-2 border-brown-light/20"
        >
          <div className="px-4 pt-2 pb-4 space-y-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="block py-2 text-brown-dark hover:text-spice transition-colors font-lato font-medium"
                onClick={() => setIsOpen(false)}
                data-testid={`mobile-nav-${link.name.toLowerCase().replace(' ', '-')}`}
              >
                {link.name}
              </Link>
            ))}
            <a
              href={SWIGGY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full bg-spice text-white px-6 py-3 rounded-full hover:bg-spice-hover transition-all text-center font-bold"
              data-testid="mobile-order-now-btn"
            >
              Order Now
            </a>
          </div>
        </motion.div>
      )}
    </motion.nav>
  );
};